var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM4.75 10C4.75 9.74536 4.76813 9.49495 4.80317 9.25H8C8.41421 9.25 8.75 8.91421 8.75 8.5C8.75 8.08579 8.41421 7.75 8 7.75H5.25522C6.09782 5.97629 7.9057 4.75 10 4.75C10.9575 4.75 11.853 5.00564 12.6245 5.4519C12.983 5.65931 13.4418 5.53678 13.6492 5.17824C13.8566 4.81969 13.7341 4.3609 13.3755 4.15349C12.3819 3.57872 11.2282 3.25 10 3.25C7.06101 3.25 4.56072 5.12832 3.63409 7.75H3C2.58579 7.75 2.25 8.08579 2.25 8.5C2.25 8.91421 2.58579 9.25 3 9.25H3.2912C3.26397 9.49625 3.25 9.74649 3.25 10C3.25 10.2535 3.26397 10.5037 3.2912 10.75H3C2.58579 10.75 2.25 11.0858 2.25 11.5C2.25 11.9142 2.58579 12.25 3 12.25H3.63409C4.56072 14.8717 7.06101 16.75 10 16.75C11.2282 16.75 12.3819 16.4213 13.3755 15.8465C13.7341 15.6391 13.8566 15.1803 13.6492 14.8218C13.4418 14.4632 12.983 14.3407 12.6245 14.5481C11.853 14.9944 10.9575 15.25 10 15.25C7.9057 15.25 6.09782 14.0237 5.25522 12.25H8C8.41421 12.25 8.75 11.9142 8.75 11.5C8.75 11.0858 8.41421 10.75 8 10.75H4.80317C4.76813 10.505 4.75 10.2546 4.75 10Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroActive);
export default __webpack_public_path__ + "static/media/EuroActive.498abbd18a90bc098fbe4d117ac6460a.svg";
export { ForwardRef as ReactComponent };